import {certificateElementType} from "~/enums/certificateElementType";
import assertNever from "../../../global/assetNever";

export default class CertificateElementDefinition {
  static getComponent(type: certificateElementType) {
    switch (type) {
      case certificateElementType.Text:
      case certificateElementType.DynamicModeText:
        return 'text-element';
      case certificateElementType.Image:
      case certificateElementType.DynamicModeImage:
        return 'image-element';
      case certificateElementType.DynamicImage:
      case certificateElementType.DynamicModeDynamicImage:
        return "dynamic-image";
      case certificateElementType.DynamicList:
      case certificateElementType.DynamicModeDynamicList:
        return "dynamic-list";
      case certificateElementType.DynamicSignature:
      case certificateElementType.DynamicModeDynamicSignature:
        return "dynamic-signature";
      case certificateElementType.Grid:
        return "grid";
      case certificateElementType.Stack:
        return "stack";
      case certificateElementType.Divider:
        return "divider";
      case certificateElementType.PageBreak:
        return "page-break"
    }
  }

  static getDisplayName(type: certificateElementType) {
    switch (type) {
      case certificateElementType.Text:
      case certificateElementType.DynamicModeText:
        return 'Text';
      case certificateElementType.Image:
      case certificateElementType.DynamicModeImage:
        return 'Image';
      case certificateElementType.DynamicImage:
      case certificateElementType.DynamicModeDynamicImage:
        return "Dynamic Image";
      case certificateElementType.DynamicSignature:
      case certificateElementType.DynamicModeDynamicSignature:
        return "Dynamic Signature";
      case certificateElementType.Page:
        return "Page";
      case certificateElementType.DynamicList:
      case certificateElementType.DynamicModeDynamicList:
        return "Dynamic List";
      case certificateElementType.Grid:
        return "Grid"
      case certificateElementType.Stack:
        return "Stack"
      case certificateElementType.Divider:
        return "Divider"
      case certificateElementType.PageBreak:
        return "Page Break"
      case certificateElementType.AdaptiveLayoutSection:
        return "Section"
    }
  }

  static getIcon(type: certificateElementType) {
    switch (type) {
      case certificateElementType.Text:
      case certificateElementType.DynamicModeText:
        return 'paragraph';
      case certificateElementType.Image:
      case certificateElementType.DynamicModeImage:
        return  'image';
      case certificateElementType.DynamicImage:
      case certificateElementType.DynamicModeDynamicImage:
        return 'dynamic-image';
      case certificateElementType.Page:
        return 'pagebreak';
      case certificateElementType.DynamicList:
      case certificateElementType.DynamicModeDynamicList:
        return 'picklist';
      case certificateElementType.DynamicSignature:
      case certificateElementType.DynamicModeDynamicSignature:
        return 'signature';
      case certificateElementType.Grid:
        return "grid"
      case certificateElementType.Stack:
        return "stack"
      case certificateElementType.Divider:
        return "divider"
      case certificateElementType.PageBreak:
        return "pagebreak"
      case certificateElementType.AdaptiveLayoutSection:
        return "section"
    }
  }
}

